/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatrixCarePatientDetailsExternalEhrPatient } from './MatrixCarePatientDetailsExternalEhrPatient';
import {
    MatrixCarePatientDetailsExternalEhrPatientFromJSON,
    MatrixCarePatientDetailsExternalEhrPatientFromJSONTyped,
    MatrixCarePatientDetailsExternalEhrPatientToJSON,
    MatrixCarePatientDetailsExternalEhrPatientToJSONTyped,
} from './MatrixCarePatientDetailsExternalEhrPatient';
import type { MatrixCarePatientDetailsUploadDocumentsRequest } from './MatrixCarePatientDetailsUploadDocumentsRequest';
import {
    MatrixCarePatientDetailsUploadDocumentsRequestFromJSON,
    MatrixCarePatientDetailsUploadDocumentsRequestFromJSONTyped,
    MatrixCarePatientDetailsUploadDocumentsRequestToJSON,
    MatrixCarePatientDetailsUploadDocumentsRequestToJSONTyped,
} from './MatrixCarePatientDetailsUploadDocumentsRequest';
import type { MatrixCarePatient } from './MatrixCarePatient';
import {
    MatrixCarePatientFromJSON,
    MatrixCarePatientFromJSONTyped,
    MatrixCarePatientToJSON,
    MatrixCarePatientToJSONTyped,
} from './MatrixCarePatient';
import type { MatrixCarePatientDetailsDocuments } from './MatrixCarePatientDetailsDocuments';
import {
    MatrixCarePatientDetailsDocumentsFromJSON,
    MatrixCarePatientDetailsDocumentsFromJSONTyped,
    MatrixCarePatientDetailsDocumentsToJSON,
    MatrixCarePatientDetailsDocumentsToJSONTyped,
} from './MatrixCarePatientDetailsDocuments';

/**
 * 
 * @export
 * @interface MatrixCarePatientDetails
 */
export interface MatrixCarePatientDetails {
    /**
     * 
     */
    patient?: MatrixCarePatient;
    /**
     * 
     */
    external_ehr_patient?: MatrixCarePatientDetailsExternalEhrPatient;
    /**
     * 
     */
    documents?: MatrixCarePatientDetailsDocuments;
    /**
     * 
     */
    upload_documents_request?: MatrixCarePatientDetailsUploadDocumentsRequest;
}

/**
 * Check if a given object implements the MatrixCarePatientDetails interface.
 */
export function instanceOfMatrixCarePatientDetails(value: object): value is MatrixCarePatientDetails {
    return true;
}

export function MatrixCarePatientDetailsFromJSON(json: any): MatrixCarePatientDetails {
    return MatrixCarePatientDetailsFromJSONTyped(json, false);
}

export function MatrixCarePatientDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatrixCarePatientDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'patient': json['patient'] == null ? undefined : MatrixCarePatientFromJSON(json['patient']),
        'external_ehr_patient': json['external_ehr_patient'] == null ? undefined : MatrixCarePatientDetailsExternalEhrPatientFromJSON(json['external_ehr_patient']),
        'documents': json['documents'] == null ? undefined : MatrixCarePatientDetailsDocumentsFromJSON(json['documents']),
        'upload_documents_request': json['upload_documents_request'] == null ? undefined : MatrixCarePatientDetailsUploadDocumentsRequestFromJSON(json['upload_documents_request']),
    };
}

export function MatrixCarePatientDetailsToJSON(json: any): MatrixCarePatientDetails {
    return MatrixCarePatientDetailsToJSONTyped(json, false);
}

export function MatrixCarePatientDetailsToJSONTyped(value?: MatrixCarePatientDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patient': MatrixCarePatientToJSON(value['patient']),
        'external_ehr_patient': MatrixCarePatientDetailsExternalEhrPatientToJSON(value['external_ehr_patient']),
        'documents': MatrixCarePatientDetailsDocumentsToJSON(value['documents']),
        'upload_documents_request': MatrixCarePatientDetailsUploadDocumentsRequestToJSON(value['upload_documents_request']),
    };
}

